import { Transition } from "@headlessui/react";

export default function ImageBackground({ image }) {
  return (
    <Transition
      as="div"
      appear={true} //THIS will make the transition run everytime the component is rendered
      show={true}
      enter="transition-opacity duration-700"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      className="h-full w-full"
    >
      <div
        className={"h-full w-full bg-cover"}
        style={{ backgroundImage: `url(${image})` }}
      ></div>
    </Transition>
  );
}
